import { cloneDeep, debounce } from 'lodash'

const filterableMixin = {
  data: function() {
    return {
      filtersClean: {}, // init (override) in component by ref
      filtersDirty: {} // init (override) in component by cloning clean
    }
  },
  computed: {
    isFiltered() {
      for (let key of Object.keys(this.filtersDirty)) {
        if (this.filtersDirty[key] !== this.filtersClean[key]) return true
      }

      return false
    },
    filterQueryParams() {
      let filters = {}

      for (let key of Object.keys(this.filtersDirty)) {
        const val = typeof this.filtersDirty[key] === 'string' ? this.filtersDirty[key].trim() : this.filtersDirty[key]

        if (!(val === undefined || val === null || val.length === 0)) {
          filters[key] = val
        }
      }

      return filters
    }
  },
  watch: {
    filtersDirty: {
      handler: debounce(function () {
        this.onFiltersUpdate()
      }, 300),
      deep: true
    }
  },
  methods: {
    onFiltersUpdate() {
      // on filters change (override in component)
    },
    clearFilters() {
      this.filtersDirty = cloneDeep(this.filtersClean)
    }
  }
}

export default filterableMixin
